import { api } from '../../services';


const activities = {
  // namespaced: true,
  state: {
    board_view_enabled: false,
    data: [],
    pagination: [],
    metrics: {
      total: {},
      pending: {},
      in_progress: {},
      expired: {},
      concluded: {},
    },
    modals: {
      initial_filter: false,
      new_activity: false,
      edit_task: false,
      confirm_delete_activity: false
    },
    fields_search: {
      channel_id: 0,
      department_id: 0,
      user_id: 0,
      status_key: 0,
      start_date: "",
      expiration_date: "",
      lead_name: "",
      lead_phone: "",
    },
    model_fields_search: {
      channel_id: 0,
      department_id: 0,
      user_id: 0,
      status_key: 0,
      start_date: "",
      expiration_date: "",
      lead_name: "",
      lead_phone: "",
    },
    current_task: {},
    current_activity: {},
    actions_of_registers: [
      {
        name: 'Editar',
        icon: 'bx bxs-edit',
        action: 'edit',
      },
      {
        name: 'Excluir',
        icon: 'bx bxs-trash',
        action: 'delete',
      },
    ],
    departments_available: [],
    operators_available: [],
    new_task_trigger: {
      active: null,
      pipeline_id: 0,
      action: null,
      days_to_expire: 0,
      hour_expire: "00:00",
      scheduled_message: null,
      file_scheduled_message: null,
    }
  },
  mutations: {
    SET_ACTIVITIES_DATA(state, payload) {
      state.data = payload
    },
    SET_ACTIVITIES_PAGINATION(state, payload) {
      state.pagination = payload
    },
    SET_METRICS_ACTIVITIES_DATA(state, payload) {
      state.metrics = payload
    },
  },
  getters: {
    filterDepartmentsAvailableOnActivities: (state) => (key, value) => {
      if (state.departments_available !== undefined) {
        return state.departments_available.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
    filterOperatorsAvailableOnActivities: (state) => (key, value) => {
      if (state.operators_available !== undefined) {
        return state.operators_available.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
  },
  actions: {
    async getAllActivities(context, fields_search) {
      await api.get(`/activities`, { params: fields_search }).then(response => {
        context.commit('SET_ACTIVITIES_DATA', response.data.data.data)
        context.commit('SET_ACTIVITIES_PAGINATION', response.data.data)
        context.commit('SET_METRICS_ACTIVITIES_DATA', response.data.metrics)
      })
    }
  }
}

export default activities;
